// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TournamentForm.css */
.tournament-form {
    display: flex;
    flex-direction: column;
    background-color: #f9f9f9;
    border-radius: 10px;
    padding: 16px;
    width: 100%;
    gap: 8px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  }

.tournament-form h2{
    text-align: center;
    color: #C3D32C;
    margin-bottom: 8px;
}

.tournament-form p{
    font-size: 14px;
    text-align: center;
    margin-bottom: 8px;
}

.tournament-form .form-group{
    display: flex;
    width: 100%;
    gap: 8px;
}

.tournament-form .form-group input{
    width: 50%;
    padding: 8px;
    border-radius: 4px;
    border: 1px solid gray;
}

.tournament-form .form-group .submit-button{
    background-color: green;
    color: white;
    border-radius: 4px;
    border: none;
    font-size: 16px;
}

.tournament-form .form-group .submit-button, .tournament-form .form-group .cancel-button{
    width: 50%;
}

.tournament-form .form-group:nth-child(5) input{
    width: 100%;
}

.tournament-form .form-group textarea{
    width: 100%;
    height: 100px;
    font-size: 14px;
    padding: 8px;
}

.additional-info-section button{
    width: 100%;
    padding: 12px;
    background: none;
    border-radius: 4px;
    border: solid 1px black;
}

.tournament-form .form-group:last-child{
    margin-top: 16px;
}

.additional-info-content .rewards-section{
    padding: 8px;
    border: 1px solid gray;
    margin-top: 8px;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.additional-info-content .rewards-section h3{
    margin-bottom: 8px;
}

.additional-info-content .reward-item input{
  width: 60% !important;
}


.additional-info-content .reward-item input[type="file"]{
  width: 40% !important;
}

.additional-info-content .reward-item button{
    width: 50px;
    background-color: #D32C2C;
    color: white;
}

.tournamentAdditional{
    padding: 8px;
    border: 1px solid gray;
    margin-top: 8px;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.tournament-form .tournamentAdditional .form-group:last-child{
    margin-top: 0;
}

.reward-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  
  .reward-item input[type="text"] {
    flex: 1 1;
    margin-right: 10px;
  }
  
  .reward-image-upload {
    display: flex;
    align-items: center;
    margin-right: 10px;
  }
  
  .upload-button {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 5px 10px;
    background-color: #f0f0f0;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
  }
  
  .upload-button:hover {
    background-color: #e0e0e0;
  }
  
  .file-name {
    margin-left: 10px;
    font-size: 0.8em;
  }
  
  .remove-reward-button {
    background: none;
    border: none;
    cursor: pointer;
    color: #ff4d4d;
  }
  
  .remove-reward-button:hover {
    color: #ff0000;
  }
  
  .add-reward-button {
    margin-top: 10px;
    background-color: #4CAF50;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .add-reward-button:hover {
    background-color: #45a049;
  }

  .reward-image-container {
    position: relative;
    display: inline-block;
  }
  
  .reward-image {
    width: 80px;
    height: 80px;
    object-fit: cover;
  }
  
  .delete-image-btn {
    position: absolute;
    top: -10px;
    left: -10px;
    width: 20px !important;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 4px !important;
  }
  
  .add-image-icon {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    border: 2px dashed #ccc;
    border-radius: 4px;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/AdminDashboard/TournamentForm.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,QAAQ;IACR,0CAA0C;EAC5C;;AAEF;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;EACE,qBAAqB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;EACpB","sourcesContent":["/* TournamentForm.css */\r\n.tournament-form {\r\n    display: flex;\r\n    flex-direction: column;\r\n    background-color: #f9f9f9;\r\n    border-radius: 10px;\r\n    padding: 16px;\r\n    width: 100%;\r\n    gap: 8px;\r\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n  }\r\n\r\n.tournament-form h2{\r\n    text-align: center;\r\n    color: #C3D32C;\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.tournament-form p{\r\n    font-size: 14px;\r\n    text-align: center;\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.tournament-form .form-group{\r\n    display: flex;\r\n    width: 100%;\r\n    gap: 8px;\r\n}\r\n\r\n.tournament-form .form-group input{\r\n    width: 50%;\r\n    padding: 8px;\r\n    border-radius: 4px;\r\n    border: 1px solid gray;\r\n}\r\n\r\n.tournament-form .form-group .submit-button{\r\n    background-color: green;\r\n    color: white;\r\n    border-radius: 4px;\r\n    border: none;\r\n    font-size: 16px;\r\n}\r\n\r\n.tournament-form .form-group .submit-button, .tournament-form .form-group .cancel-button{\r\n    width: 50%;\r\n}\r\n\r\n.tournament-form .form-group:nth-child(5) input{\r\n    width: 100%;\r\n}\r\n\r\n.tournament-form .form-group textarea{\r\n    width: 100%;\r\n    height: 100px;\r\n    font-size: 14px;\r\n    padding: 8px;\r\n}\r\n\r\n.additional-info-section button{\r\n    width: 100%;\r\n    padding: 12px;\r\n    background: none;\r\n    border-radius: 4px;\r\n    border: solid 1px black;\r\n}\r\n\r\n.tournament-form .form-group:last-child{\r\n    margin-top: 16px;\r\n}\r\n\r\n.additional-info-content .rewards-section{\r\n    padding: 8px;\r\n    border: 1px solid gray;\r\n    margin-top: 8px;\r\n    border-radius: 4px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n}\r\n\r\n.additional-info-content .rewards-section h3{\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.additional-info-content .reward-item input{\r\n  width: 60% !important;\r\n}\r\n\r\n\r\n.additional-info-content .reward-item input[type=\"file\"]{\r\n  width: 40% !important;\r\n}\r\n\r\n.additional-info-content .reward-item button{\r\n    width: 50px;\r\n    background-color: #D32C2C;\r\n    color: white;\r\n}\r\n\r\n.tournamentAdditional{\r\n    padding: 8px;\r\n    border: 1px solid gray;\r\n    margin-top: 8px;\r\n    border-radius: 4px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n}\r\n\r\n.tournament-form .tournamentAdditional .form-group:last-child{\r\n    margin-top: 0;\r\n}\r\n\r\n.reward-item {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-bottom: 10px;\r\n  }\r\n  \r\n  .reward-item input[type=\"text\"] {\r\n    flex: 1;\r\n    margin-right: 10px;\r\n  }\r\n  \r\n  .reward-image-upload {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-right: 10px;\r\n  }\r\n  \r\n  .upload-button {\r\n    display: flex;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    padding: 5px 10px;\r\n    background-color: #f0f0f0;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .upload-button:hover {\r\n    background-color: #e0e0e0;\r\n  }\r\n  \r\n  .file-name {\r\n    margin-left: 10px;\r\n    font-size: 0.8em;\r\n  }\r\n  \r\n  .remove-reward-button {\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    color: #ff4d4d;\r\n  }\r\n  \r\n  .remove-reward-button:hover {\r\n    color: #ff0000;\r\n  }\r\n  \r\n  .add-reward-button {\r\n    margin-top: 10px;\r\n    background-color: #4CAF50;\r\n    color: white;\r\n    border: none;\r\n    padding: 10px 15px;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .add-reward-button:hover {\r\n    background-color: #45a049;\r\n  }\r\n\r\n  .reward-image-container {\r\n    position: relative;\r\n    display: inline-block;\r\n  }\r\n  \r\n  .reward-image {\r\n    width: 80px;\r\n    height: 80px;\r\n    object-fit: cover;\r\n  }\r\n  \r\n  .delete-image-btn {\r\n    position: absolute;\r\n    top: -10px;\r\n    left: -10px;\r\n    width: 20px !important;\r\n    height: 20px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background: transparent;\r\n    border: none;\r\n    cursor: pointer;\r\n    padding: 4px !important;\r\n  }\r\n  \r\n  .add-image-icon {\r\n    cursor: pointer;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 50px;\r\n    height: 50px;\r\n    border: 2px dashed #ccc;\r\n    border-radius: 4px;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
